module.exports = __webpack_public_path__ + "static/img/hklc.e3336a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/hklc.png
// module id = MDBI
// module chunks = 1